import React from 'react';
import { Container, Card, CardActionArea, Typography, Box, Grid } from '@mui/material';
import StepperSidebar from './StepperSidebar';

const warmColor = '#e67e22';
const warmColorDark = '#d35400';

const osOptions = [
    {
        key: 'windows',
        label: 'Windows',
        description: 'Il laboratorio si baserà su sistema operativo Windows.',
        icon: '/reqLabOsWin.png',
    },
    {
        key: 'linux',
        label: 'Linux',
        description: 'Il laboratorio si baserà su sistema operativo Linux.',
        icon: '/reqLabOsTux.png',
    },
];

function SelectBaseOs(props) {
    return (
        <Container maxWidth="lg">
            <Box mb={3}>
                <Typography variant="h6" fontWeight="bold">
                    Scegli il Sistema Operativo
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Seleziona il sistema operativo su cui basare il laboratorio
                </Typography>
            </Box>

            <Card sx={{ p: 3, borderRadius: 3 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={3}>
                            {osOptions.map((opt) => (
                                <Grid item xs={12} sm={6} key={opt.key}>
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            borderRadius: 3,
                                            border: '2px solid #eee',
                                            overflow: 'hidden',
                                            transition: 'all 0.25s ease',
                                            '&:hover': {
                                                borderColor: warmColor,
                                                transform: 'translateY(-4px)',
                                                boxShadow: `0 12px 28px rgba(230, 126, 34, 0.18)`,
                                            },
                                        }}
                                    >
                                        <CardActionArea
                                            onClick={() => props.handleSelectOs(opt.key)}
                                            sx={{
                                                p: 4,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                minHeight: 260,
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={opt.icon}
                                                alt={opt.label}
                                                sx={{
                                                    width: 64,
                                                    height: 64,
                                                    mb: 2.5,
                                                    objectFit: 'contain',
                                                }}
                                            />
                                            <Typography variant="h5" fontWeight="bold" gutterBottom>
                                                {opt.label}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                                {opt.description}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    mt: 'auto',
                                                    width: '100%',
                                                    py: 1.2,
                                                    borderRadius: 2,
                                                    bgcolor: warmColor,
                                                    color: '#fff',
                                                    fontWeight: 600,
                                                    fontSize: '0.95rem',
                                                    textAlign: 'center',
                                                    transition: 'background-color 0.2s',
                                                    '&:hover': { bgcolor: warmColorDark },
                                                }}
                                            >
                                                Seleziona
                                            </Box>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <StepperSidebar
                            currentStep={props.currentStep}
                            statusForm={props.statusForm}
                            steps={props.stepsConfig}
                            onBack={props.prevStep}
                        />
                    </Grid>
                </Grid>
            </Card>
        </Container>
    );
}

export default SelectBaseOs;
